module.exports = __webpack_public_path__ + "static/media/favicon_ffstars_v2.6848c342.png";